import { Navigate, useParams } from "react-router"
import { useDealerAppRoutes } from "src/common/routes/useDealerAppRoutes"

// purchaseRequests.details used to live at /purchase-requests/details/:id before the "details" segment was
// dropped in favor of /purchase-requests/:id. This keeps old bookmarked/shared links working by mapping the
// legacy path shape onto the new one. This is important since links are sent out via email.
export const LegacyPurchaseRequestDetailsRedirect = () => {
	const { id } = useParams<{ id: string }>()
	const routes = useDealerAppRoutes()

	if (!id || !routes?.purchaseRequests?.details) {
		return null
	}

	return <Navigate to={routes.purchaseRequests.details.url(id)} replace />
}
